import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';
import { Box } from '@mui/material';

const ItemMetaData = ({
    label,
    value,
}: {
    label: string;
    value: string | number;
}): React.ReactElement => (
    <Grid
        spacing={3}
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
    >
        <Typography> {label} </Typography>
        <Typography color="primary"> {value}</Typography>
    </Grid>
);

type Props = {
    metadata: {
        lastUpdatedDate: string;
        rowNumber: number;
        lastImportedFileName: string;
        ownerEmail: string;
    };
};
const Metadata = (props: Props): React.ReactElement => {
    const { t } = useTranslation();
    const { metadata } = props;
    return (
        <Box sx={{ m: '1rem' }}>
            <Grid
                container
                wrap="wrap"
                direction="row"
                justifyContent="flex-start"
                alignItems="baseline"
                spacing={3}
            >
                <ItemMetaData
                    label={t('importCSV.dataSource')}
                    value={t('extraFeatures.csvImport')}
                />
                <ItemMetaData
                    label={t('importCSV.rowNumber')}
                    value={metadata.rowNumber}
                />
                <ItemMetaData
                    label={t('importCSV.lastImportedFileName')}
                    value={metadata.lastImportedFileName}
                />
                <ItemMetaData
                    label={t('importCSV.lastUpdatedDate')}
                    value={metadata.lastUpdatedDate}
                />
                <ItemMetaData
                    label={t('importCSV.createdBy')}
                    value={metadata.ownerEmail}
                />
            </Grid>
        </Box>
    );
};

export default Metadata;
